import { useWSSnackbar } from "@wingspanhq/fe-component-library";
import React, { useCallback, useEffect } from "react";
import { WSQueryCache } from "@ws-react-query";
import { RouteComponentProps } from "react-router-dom";
import { sessionService } from "@services/sessionService";
import { usersService } from "../services/users";
import { useResetWSStore } from "../store";
import { reset as analyticsReset, track } from "../utils/analytics";

export const SignOut: React.FC<
  RouteComponentProps<
    {},
    {},
    {
      forceLogout?: boolean;
    }
  >
> = ({ history, location }) => {
  const resetWSStore = useResetWSStore();
  const snackbar = useWSSnackbar();

  const reset = useCallback(() => {
    WSQueryCache.clear();
    window.sessionStorage.removeItem("partner");
    window.localStorage.removeItem("signUp1099");
    window.localStorage.removeItem("invoiceCurrency");
    resetWSStore();

    analyticsReset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const logout = useCallback(async () => {
    try {
      if (location.state?.forceLogout) {
        snackbar.openSnackbar({
          message:
            "For security reasons, your login has timed out. Please log in again to continue.",
          icon: {
            name: "logout"
          }
        });
      }

      // Tear down both sessions during the migration: the v1 session via the
      // users service, and the v3 session via the session service — which
      // deletes the session server-side and clears the in-memory access token
      // and the persisted refresh token, leaving no tokens behind. allSettled
      // so a failure on one side can't strand the other or block local cleanup.
      await Promise.allSettled([
        usersService.session.delete(),
        sessionService.logout()
      ]);

      reset();

      track("Auth", { action: "Log Out" });

      const redirectTo = location.hash
        ? location.hash.slice(1)
        : "/member/sign-in";

      history.replace(redirectTo);
    } catch (error) {
      console.log("logout error");
      console.error(error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    logout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
